import { QUESTIONS } from "../../constants";

export function determineThinkType(answers: { [qNumber: number]: number }) {
  const thinkScore = QUESTIONS.filter(q => q.type === 'DC').reduce((acc, q) => {
      return acc + answers[q.number];
  }, 0);

  if (thinkScore >= -24 && thinkScore <= -17) {
      return 'Freethinker';
  } else if (thinkScore >= -16 && thinkScore <= -7) {
      return 'Brainstormer';
  } else if (thinkScore >= -6 && thinkScore <= -2) {
      return 'Originator';
  } else if (thinkScore >= -1 && thinkScore <= 1) {
      return 'Fusionist';
  } else if (thinkScore >= 2 && thinkScore <= 6) {
      return 'Practical';
  } else if (thinkScore >= 7 && thinkScore <= 16) {
      return 'Realist';
  } else {
      return 'Logical';
  }
}

export function determinePerceiveType(answers: { [qNumber: number]: number }) {
  const perceiveScore = QUESTIONS.filter(q => q.type === 'PS').reduce((acc, q) => {
      return acc + answers[q.number];
  }, 0);

  if (perceiveScore >= -24 && perceiveScore <= -17) {
      return 'Distinguisher';
  } else if (perceiveScore >= -16 && perceiveScore <= -7) {
      return 'Detail-Oriented';
  } else if (perceiveScore >= -6 && perceiveScore <= -2) {
      return 'Nuancer';
  } else if (perceiveScore >= -1 && perceiveScore <= 1) {
      return 'Adaptor';
  } else if (perceiveScore >= 2 && perceiveScore <= 6) {
      return 'Insightful';
  } else if (perceiveScore >= 7 && perceiveScore <= 16) {
      return 'Visionary';
  } else {
      return 'Connector';
  }
}

export function determineEngageType(answers: { [qNumber: number]: number }) {
  const engageScore = QUESTIONS.filter(q => q.type === 'RT').reduce((acc, q) => {
      return acc + answers[q.number];
  }, 0);

  if (engageScore >= -24 && engageScore <= -17) {
      return 'Deliberator';
  } else if (engageScore >= -16 && engageScore <= -7) {
      return 'Incubator';
  } else if (engageScore >= -6 && engageScore <= -2) {
      return 'Strategizer';
  } else if (engageScore >= -1 && engageScore <= 1) {
      return 'Experimenter';
  } else if (engageScore >= 2 && engageScore <= 6) {
      return 'Pragmatist';
  } else if (engageScore >= 7 && engageScore <= 16) {
      return 'Explorer';
  } else {
      return 'Doer';
  }
}

export function linkTo(url: string) {
    window.parent.postMessage(url, "*");
}